import { render, staticRenderFns } from "./_AppNavigatorLink.vue?vue&type=template&id=c3495e40&"
import script from "./_AppNavigatorLink.vue?vue&type=script&lang=js&"
export * from "./_AppNavigatorLink.vue?vue&type=script&lang=js&"
import style0 from "./_AppNavigatorLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports